export const EXPERIENCE_LEVELS = [
  { id: "never", label: "Never played" },
  { id: "recreational", label: "Recreational player" },
  { id: "high_school", label: "High school player" },
  { id: "college", label: "College player" },
  { id: "professional", label: "Professional / Semi-pro" },
  { id: "coach", label: "Coach / Trainer" },
];

export const YEARS_EXPERIENCE = [
  { id: "0-1", label: "0–1 years" },
  { id: "2-4", label: "2–4 years" },
  { id: "5-8", label: "5–8 years" },
  { id: "8+", label: "8+ years" },
];

export const FITNESS_LEVELS = [
  { id: "beginner", label: "Beginner" },
  { id: "average", label: "Average" },
  { id: "athletic", label: "Athletic" },
  { id: "high_performance", label: "High performance" },
];

export const TRAINING_PACE = [
  { id: "yes", label: "Yes, advanced pace" },
  { id: "moderate", label: "Moderate pace only" },
  { id: "beginner", label: "Beginner sessions only" },
];

export const SERVICES = [
  "rebounding",
  "passing drills",
  "shooting workouts",
  "conditioning drills",
  "footwork drills",
  "timing / stopwatch",
  "recording workout videos",
  "defensive dummy drills",
];

export const AVAILABILITY_SLOTS = ["mornings", "afternoons", "evenings", "weekends"];
export const TRANSPORT_METHODS = ["walk", "bike", "car", "public"];
export const ENCOURAGEMENT = [
  { id: "hype", label: "Yes — hype energy" },
  { id: "quiet", label: "Quiet helper only" },
];

export const BUILTIN_SPORTS = ["basketball", "soccer", "tennis", "volleyball", "baseball"];

export const COMMON_POSITIONS = {
  basketball: ["point guard", "shooting guard", "small forward", "power forward", "center"],
  soccer: ["goalkeeper", "defender", "midfielder", "forward"],
  baseball: ["pitcher", "catcher", "infielder", "outfielder"],
  volleyball: ["setter", "libero", "outside hitter", "middle blocker"],
  tennis: ["singles", "doubles"],
};
